export function getApiBaseUrl() {
  // specify when backend functions and frontend are deployed to a different URL
  return "";
}
